import React from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import i18next from 'i18next';

type Props = {
  kind: Number;
};

const AlarmKindDiv: React.FC<Props> = (props) => {
  const { t, i18n } = useTranslation();
  let label = ConvertKind(props.kind, t);
  return <div>{label}</div>;
};

export const ConvertKind = (kind: Number, trans: TFunction<'translation'>): string => {
  let label = '';
  switch (kind) {
    case 1:
      label = i18next.t('AlarmKindDiv.重故障', '重故障');
      break;
    case 2:
      label = i18next.t('AlarmKindDiv.軽故障', '軽故障');
      break;
    case 3:
      label = i18next.t('AlarmKindDiv.システム異常', 'システム異常');
      break;
    case 4:
      label = i18next.t('AlarmKindDiv.モータ停止', 'モータ停止');
      break;
    case 21:
    case 23:
      label = i18next.t('AlarmKindDiv.上限異常', '上限異常');
      break;
    case 22:
    case 24:
      label = i18next.t('AlarmKindDiv.上上限異常', '上上限異常');
      break;
    default:
      label = i18next.t('AlarmKindDiv.不明', '不明');
  }

  return label;
};

export default AlarmKindDiv;
